export default __webpack_public_path__ + "ae7adcb902e7e6ac81dea0e5c40c1df8.png";